module.exports = __webpack_public_path__ + "static/img/brees-2009-top-image.0a4c23c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-top-image.jpg
// module id = fRDn
// module chunks = 1